import { MeleeEntity } from "./MeleeEntity";

/** Heavy melee enemy with its laser wind-up and large slash effects. */
export class HeavyMeleeEntity extends MeleeEntity {
  override get isHeavyMelee(): boolean {
    return true;
  }

  override get usesLargeEffects(): boolean {
    return true;
  }

  override get keepsFacingSheet(): boolean {
    return true;
  }

  override get meleeDamage(): number {
    return 45;
  }

  protected override updateMeleeCharge(returnAction: number): number {
    const counter = this.slashData.counter;
    if (counter !== 30 && counter !== 50 && counter !== 60 && counter !== 70) {
      return returnAction;
    }
    this.frameLimit = 1;
    this.frame = 0;
    this.animOffset = 20;
    this.frameCounter = 0;
    return counter >= 50 ? 6 : returnAction;
  }

  protected override slashAction(flipped: boolean): number {
    return flipped ? 5 : 4;
  }
}
